import BaseRepository from "@/services/resources/repository";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema);
    }

    record(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .include('person-specialisations')
                    .include('person-departments')
                    .find(id)
            )
        );
    }

    bySlug(slug) {
        const pieces = slug.split('-');

        if (pieces.length !== 2) {
            return Promise.resolve(null);
        }

        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .where('firstName', pieces[0])
                    .where('lastName', pieces[1])
                    .first()
            )
        );
    }

    getWithCitationsAndMedia(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .include('person-citations.citations')
                    .include('person-news.news')
                    .include('person-blog-posts.blog-posts')
                    .include('person-podcasts.podcasts')
                    .find(id)
            )
        );
    }

    search(keywords) {
        return this.transformer.many(
            this.try(
                this.baseSearchQuery(
                    ['person-modules.modules.modules'],
                    ['firstName', 'lastName', 'summary', 'description', 'appointments', 'memberships', 'person-modules.modules.modules.attributes']
                    , keywords
                ).get()
            )
        ).then(collection => {
            return collection.map(record => {
                return {
                    type: 'people',
                    id: record.id,
                    text: `${record.firstName} ${record.lastName}`,
                    resource: record
                }
            })
        })
    }
}

export default Repository;
